import { Capacitor } from '@capacitor/core';
export class PlatformDetector {
    static _instance;
    _info = null;
    constructor() { }
    static getInstance() {
        if (!PlatformDetector._instance) {
            PlatformDetector._instance = new PlatformDetector();
        }
        return PlatformDetector._instance;
    }
    getPlatformInfo() {
        if (!this._info) {
            this._info = this.detectPlatform();
        }
        return this._info;
    }
    detectPlatform() {
        // Check if running in Capacitor (native app)
        const isNative = Capacitor.isNativePlatform();
        if (isNative) {
            // Determine if iOS or Android
            const platform = Capacitor.getPlatform();
            return {
                platform: platform === 'ios' ? 'ios' : 'android',
                isNative: true,
                isMobile: true,
                canUseLocalNotifications: true,
                canUsePushNotifications: true,
                hasServiceWorker: false
            };
        }
        // Web environment - check for mobile browser
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = this.detectMobileBrowser(userAgent);
        const hasServiceWorker = 'serviceWorker' in navigator;
        const canUseNotifications = 'Notification' in window;
        // Determine platform for web
        let platform = 'web';
        if (isMobile) {
            if (/iphone|ipad|ipod/.test(userAgent)) {
                platform = 'ios';
            }
            else if (/android/.test(userAgent)) {
                platform = 'android';
            }
        }
        return {
            platform,
            isNative: false,
            isMobile,
            canUseLocalNotifications: canUseNotifications,
            canUsePushNotifications: canUseNotifications && hasServiceWorker,
            hasServiceWorker
        };
    }
    detectMobileBrowser(userAgent) {
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/.test(userAgent);
    }
    // Convenience methods
    isIOS() {
        return this.getPlatformInfo().platform === 'ios';
    }
    isAndroid() {
        return this.getPlatformInfo().platform === 'android';
    }
    isWeb() {
        return !this.getPlatformInfo().isNative;
    }
    isNative() {
        return this.getPlatformInfo().isNative;
    }
    isMobile() {
        return this.getPlatformInfo().isMobile;
    }
    canUseLocalNotifications() {
        return this.getPlatformInfo().canUseLocalNotifications;
    }
    canUsePushNotifications() {
        return this.getPlatformInfo().canUsePushNotifications;
    }
}
// Export singleton instance
export const platformDetector = PlatformDetector.getInstance();
